import { useState, useEffect, useRef, useMemo } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { getGroups } from "../../services/RetreatServices";
import { Button } from "react-bootstrap"; // or the appropriate library

export default function WaiverForm() {
  const [groupData, setGroupData] = useState(null);
  const signatureRef = useRef(null);
  const [searchParams] = useSearchParams();
  //const registrationID = searchParams.get("registrationID");
  //const retreatID = 3;
  // Extract query params
  const registrationID = searchParams.get("registrationID");
  const retreatID = searchParams.get("retreatID");

  // Memoize filters to prevent unnecessary re-renders
  const filters = useMemo(
    () => ({ registrationID, retreatID }),
    [registrationID, retreatID]
  );

  useEffect(() => {
    console.log("Query Params:", { registrationID, retreatID });
    console.log("WaiverForm filters", filters);
    if (!registrationID || !retreatID) {
      console.error("Missing query parameters: registrationID or retreatID");
      return;
    }
    getGroups(filters)
      .then((data) => {
        if (data && data.length > 0) {
          console.log("Participant data:", data[0]);
          setGroupData(data[0]);
        } else {
          console.error("Participant data not found");
        }
      })
      .catch((error) =>
        console.error("Error fetching participant data:", error)
      );
  }, [filters]);

  const handleSubmit = async () => {
    if (!signatureRef.current || signatureRef.current.isEmpty()) {
      alert("Please sign the waiver");
      return;
    }

    const response = await fetch("/api/submit-waiver", {
      method: "POST",
      body: JSON.stringify({
        retreatID,
        registrationID,
        signature: signatureRef.current.toDataURL(),
      }),
      headers: { "Content-Type": "application/json" },
    });

    if (response.ok) {
      alert("Waiver submitted successfully!");
    }
  };

return (
    <div
        style={{
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
        }}
    >
        <div
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/Retreat_Waiver_3.png)`,
                height: "200px", // Set a height to ensure the div is visible
                backgroundSize: "cover", // Optional: Ensure the image covers the div
            }}
        ></div>
        {groupData?.groupMembers?.length > 0 ? (
            <>
                <h2 className="text-xl font-bold text-center mb-4 text-black">
                    Krupabhishekam Retreat 2025 Waiver Form
                </h2>
                <p className="text-center mb-4 text-black">
                    <strong>Event:</strong> Krupabhishekam Retreat 2025 at St. Mary’s
                    Syro-Malabar Catholic Church, Old Bethpage, NY (hereinafter referred
                    to as the “Retreat”)
                </p>
                <p>
                    I willingly accept all risks, known and unknown, associated with
                    participating in retreat activities, including those related to
                    parking and the use of any shuttle or transportation services.
                </p>
                <p>
                    I agree, for myself, my heirs, and assigns, to hold harmless and
                    release any participating individuals, organizers, St. Mary’s
                    Syro-Malabar Church, the Syro-Malabar Diocese of Chicago, and any
                    other sponsoring organizations, including their respective
                    subsidiaries, affiliates, officers, directors, trustees,
                    secretaries, volunteers, employees, agents, representatives,
                    successors, and licensees (collectively, “Released Parties”), from
                    any and all losses, liabilities, expenses, causes of action, and
                    claims for damages (“Claims”) that I may now or in the future have.
                    These Claims may arise directly or indirectly from my participation
                    in retreat activities; the use of any parking locations arranged for
                    the retreat; the use of any shuttle or other transportation services
                    provided or arranged; or the condition of the property, facilities,
                    or equipment used during the retreat. This release applies
                    regardless of when, where, or how such Claims arise and whether they
                    are caused by the negligence of the Released Parties or otherwise.
                    This includes, but is not limited to, Claims relating to:
                </p>
                <ol type="i">
                    <li>Any theft, loss, or disappearance of property.</li>
                    <li>Bodily injury (fatal or non-fatal).</li>
                    <li>Property damage.</li>
                </ol>
                <p>
                    This agreement will be construed broadly to prevent claims and
                    lawsuits to the maximum extent permissible under applicable law. Any
                    provisions found to be void or unenforceable shall be modified or
                    deleted to the minimum extent necessary to make them enforceable and
                    shall not affect the enforceability of any other provisions.
                </p>
                <p>
                    I have read this agreement, fully understand its terms, and
                    recognize that I have given up certain legal rights by signing it in
                    consideration of being permitted to participate in retreat
                    activities, and to use parking and any shuttle or transportation
                    services.
                </p>
                <p>
                    I sign this agreement voluntarily and without any inducement or
                    duress.
                </p>
                <p>
                    Participant Name : 
                    <u>{` ${groupData.groupMembers[0].firstName} ${groupData.groupMembers[0].lastName}  `}</u>
                    <p> Date : <u>{new Date().toLocaleDateString()}</u></p> 
                </p>
                <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                        className: "border border-black rounded",
                        width: 200,
                        height: 100,
                    }}
                    ref={signatureRef}
                />

                <Button onClick={handleSubmit} className="mt-4">
                    Submit Waiver
                </Button>
            </>
        ) : (
            <p>Loading...</p>
        )}
    </div>
);
}
